import { useCallback, useEffect, useRef } from "react";

export const useDebounce = (callback: () => void, delay: number) => {
  const callbackRef = useRef(callback);
  const debounceTimerRef = useRef(0);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);

  return useCallback(() => {
    if (debounceTimerRef.current) window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(() => callbackRef.current(), delay);
  }, [delay]);
};
